<!-- 登陆 -->
<template>
  <div class="login">
    <div class="login-warp">
      <div class="warp-header">
        <img src="./images/guo-b.png" />
        <span class="header-title">国家药品追溯监管系统</span>
      </div>
      <div class="warp-concent">
        <div class="concent-box">
          <div
            class="concent-form"
            :style="{ height: loginTab == '2' ? '500px' : '454px' }"
          >
            <div class="form-frame">
              <div class="form-frame-header">
                <div class="left">登录</div>

                <div class="right" v-if="loginTab == '2'">
                  请插入Ukey进行身份验证
                </div>
              </div>
              <div
                class="form-pwd"
                :style="{ 'padding-bottom': loginTab == '2' ? '30px' : '0px' }"
              >
                <a-button
                  html-type="submit"
                  class="down-button"
                  v-if="loginTab == '2'"
                  @click="downloadNote"
                  >Ukey使用说明</a-button
                >

                <a-button
                  html-type="submit"
                  class="down-button"
                  v-if="loginTab == '2'"
                  @click="downloadDriver"
                  >Ukey驱动下载</a-button
                >

                <a-form-model
                  ref="ruleForm"
                  :model="form"
                  :rules="rules"
                  :colon="false"
                >
                  <a-form-model-item prop="username" v-if="loginTab == '1'">
                    <a-input
                      v-model="form.username"
                      placeholder="请输入账号"
                    >
                      <div slot="prefix" class="input-icon">
                        <img src="./images/user.png" alt="验证码" />
                      </div>
                    </a-input>
                  </a-form-model-item>

                  <a-form-model-item prop="password">
                    <a-input-password
                      v-model="form.password"
                      placeholder="请输入登录密码"
                      type="password"
                    >
                      <div slot="prefix" class="input-icon">
                        <img src="./images/pwd.png" alt="验证码" />
                      </div>
                    </a-input-password>
                  </a-form-model-item>

                  <a-form-model-item prop="captcha">
                    <a-row :gutter="10">
                      <a-col :span="15">
                        <a-input
                          v-model="form.captcha"
                          placeholder="请输入验证码"
                          :maxLength="4"
                        >
                          <div slot="prefix" class="input-icon">
                            <img src="./images/yzm.png" alt="验证码" />
                          </div>
                        </a-input>
                      </a-col>

                      <a-col :span="9">
                        <div class="login-form-code" @click="getVerify">
                          <img :src="codeImg" alt="验证码" />
                        </div>
                      </a-col>
                    </a-row>
                  </a-form-model-item>

                  <a-form-model-item
                    class="login-btn"
                    :style="{
                      'margin-bottom': loginTab == '2' ? '10px' : '50px',
                    }"
                  >
                    <a-button
                      type="primary"
                      html-type="submit"
                      class="login-form-button"
                      :loading="loading"
                      @click="handleSubmit"
                      :style="{
                        'margin-bottom': loginTab == '2' ? '0px' : '6px',
                      }"
                      >登录</a-button
                    >
                  </a-form-model-item>
                  <div class="tip" v-if="loginTab == '2'">
                    第一次登录需下载Ukey驱动并安装
                  </div>
                </a-form-model>
              </div>
              <div class="footer-tab">
                <span
                  class="pwd"
                  @click="getLoginType('1')"
                  :style="{ color: loginTab == '1' ? '#0B51C1' : '#A1A6B3' }"
                >
                  <img
                    :src="
                      loginTab == '1'
                        ? require('./images/pwd_way_active.png')
                        : require('./images/pwd_way.png')
                    "
                  />
                  密码登录</span
                >
                <span class="round-dot"> · </span>
                <span
                  class="ukey"
                  @click="getLoginType('2')"
                  :style="{ color: loginTab == '2' ? '#0B51C1' : '#A1A6B3' }"
                >
                  <img
                    :src="
                      loginTab == '2'
                        ? require('./images/uk_way_active.png')
                        : require('./images/uk_way.png')
                    "
                  />ukey登录</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="warp-footer">
        <div class="footer-top">
          <span>本站由国家药品监督管理局主办版权所有：国家药品监督管理局</span>
        </div>
        <div class="footer-top">
          <span>Copyright @ NMPA All Rights Reserved</span>
        </div>
        <div class="footer-top">
          <span
            >网站标识码bm35000001 各案序号：京ICP各13027807号
            <img src="./images/guo-s.png" /> 京公网安各11010202008311号</span
          >
        </div>
        <div class="footer-top">
          <span>地址：北京市经济技术开发区广德大街22号院一区4号楼</span>
          <span class="pl20">邮编：100076</span>
          <span class="pl20">局总机：68311166</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import API from "@/api/login";
import COMMONAPI from "@/api/common";
import "./index.less";
export default {
  data() {
    return {
      form: {
        username: "", // 账号
        password: "", // 密码 TYDL_gj2023
        captcha: "", // 验证码
      },
      codeImg: "",
      ticket: "", // 验证码接口获取
      rules: {
        username: [
          { required: true, message: "请输入账号!", trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入登录密码!", trigger: "change" },
        ],
        captcha: [
          { required: true, message: "请输入验证码!", trigger: "change" },
        ],
      },

      loading: false,
      loginTab: "1",
    };
  },

  mounted() {
    localStorage.removeItem("token");
    window.clearVuexAlong();
    this.$store.commit("tabs/setTabs"); // 清空页签列表
    this.getVerify();
  },

  computed: {
    ...mapState(["menus"]),
  },

  methods: {
    // 登陆方式
    getLoginType(type) {
      this.loginTab = type;
    },

    // 获取验证码
    getVerify() {
      API.getVerify({}, (callback) => {
        if (callback.status == "S" && callback.data) {
          this.codeImg = `data:image/png;base64,${callback.data.img}`;

          this.ticket = callback.data.ticket || "";
        }
      });
    },

    // 登录表单校验
    handleSubmit() {
      const menuList = [
        {
          id: "01",
          authName: "工作台",
          iconClass: "work",
          target: "_blank",
          link: "/work",
          parentId: "0",
          level: "0",
        },

        {
          id: "02",
          authName: "日志管理",
          iconClass: "logAdmin",
          link: "",
          parentId: "0",
          level: "0",
          children: [
            {
              id: "0202",
              authName: "登录时间统计",
              iconClass: "",
              link: "/page/logAdmin/logTimeStatistics",
              level: "1",
              parentId: "02",
            },
            {
              id: "0201",
              authName: "日志查询",
              iconClass: "",
              link: "/page/logAdmin/logSearch",
              level: "1",
              parentId: "02",
            },
          ],
        },

        {
          id: "03",
          authName: "通知公告管理",
          iconClass: "noticeAnnounce",
          link: "",
          parentId: "0",
          level: "0",
          children: [
            {
              id: "0301",
              authName: "通知公告管理",
              iconClass: "",
              link: "/page/noticeAnnounce/noticeManage",
              level: "1",
              parentId: "03",
            },
          ],
        },

        {
          id: "04",
          authName: "应用管理",
          iconClass: "appModule",
          link: "",
          parentId: "0",
          level: "0",
          children: [
            {
              id: "0401",
              authName: "应用管理",
              iconClass: "",
              link: "/page/appModule/appManage",
              level: "1",
              parentId: "04",
            },
          ],
        },

        {
          id: "05",
          authName: "系统管理",
          iconClass: "sysManage",
          link: "",
          parentId: "0",
          level: "0",
          children: [
            {
              id: "0501",
              authName: "角色管理",
              iconClass: "",
              link: "/page/sysManage/roleManage",
              level: "1",
              parentId: "05",
            },
            {
              id: "0502",
              authName: "用户管理",
              iconClass: "",
              link: "/page/sysManage/userManage",
              level: "1",
              parentId: "05",
            },
            {
              id: "0503",
              authName: "组织机构管理",
              iconClass: "",
              link: "/page/sysManage/orgManage",
              level: "1",
              parentId: "05",
            },
            {
              id: "0504",
              authName: "部门管理",
              iconClass: "",
              link: "/page/sysManage/departmentManage",
              level: "1",
              parentId: "05",
            },
          ],
        },
      ];
      let _this = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.loginTab == "1") {
            _this.login();
          } else {
            _this.listenUkey();
          }
        }
      });
    },

    ukLogin(
      ukeyLoginParams = {
        certId: "",
        signedData: "",
        strRandom: "",
        userCert: "",
      }
    ) {
      this.loading = true;
      API.caLogin(
        {
          data: {
            params: {
              ...ukeyLoginParams,
            },
          },
        },
        (callback) => {
          this.loading = false;
          if (callback.status == "S" && callback.data) {
            const userInfo = callback.data;
            if (userInfo.token) {
              localStorage.setItem("token", userInfo.token);
            }
            this.setUserInfo(callback.data.user);
            if (Array.isArray(userInfo.menus) && userInfo.menus.length > 0) {
              let menus = [];
              // this.$router.push("/");
              menus = userInfo.menus;
              this.setMenus(menus);
              if (menus[0].children.length == 0) {
                this.$router.push(menus[0].path);
              } else {
                this.$router.push(menus[0].children[0].path);
              }
              // this.$router.push(menus[0].path);
            }
          } else {
            this.form.captcha = "";
            this.getVerify();
          }
        }
      );
    },

    signCert(code, id) {
      var rendom = code;
      CurrentInterface.SOF_SignData(id, rendom, (retObj) => {
        var datas = retObj.retVal;
        CurrentInterface.SOF_ExportUserCert(id, (retObjCert) => {
          var publicKey = retObjCert.retVal;
          const p = {
            certId: id,
            signedData: datas,
            strRandom: rendom,
            userCert: publicKey,
          };
          this.ukLogin(p);
        });
      });
    },
    // uk登陆
    listenUkey() {
      console.log("CurrentInterface", window);
      var num = 0; // 监控ukey插入
      CurrentInterface.SOF_GetUserList((retObj) => {
        ++num; // 读取到ukey信息时，标记
        var list = retObj.retVal; // 读取ukey的key
        if (list !== "") {
          var id = list.match(/\/(\S*)&&&/)[1]; // 筛选出id
          if (id.length > 16) {
            // 当ukey插入超过一个时
            this.$message.error("USBkey只允许插入一枚，请拔掉多余的USBkey!");
          } else {
            CurrentInterface.SOF_Login(
              id,
              this.form.password,
              async (retObj) => {
                var pwd = retObj.retVal;
                if (pwd) {
                  try {
                    API.getNonce(
                      {
                        data: {
                          params: {
                            captcha: this.form.captcha,
                            ticket: this.ticket,
                          },
                        },
                      },
                      (callback) => {
                        let verifyResult = {};
                        if (callback.status == "S" && callback.data) {
                          verifyResult = callback.data;
                          this.signCert(verifyResult.code || "", id || "");
                        }
                      }
                    );
                  } catch (e) {
                    this.getVerify();
                  }
                } else {
                  CurrentInterface.SOF_GetPinRetryCount(id, (retObj) => {
                    var retryCount = Number(retObj.retVal);
                    if (retryCount > 0) {
                      this.$message.error(
                        "校验证书密码失败!您还有" + retryCount + "次机会重试!"
                      );
                    } else if (retryCount === 0) {
                      this.$message.error(
                        "您的证书密码已被锁定,请联系BJCA进行解锁!"
                      );
                    } else {
                      this.$message.error("登录失败");
                    }
                  });
                  this.form.password = "";
                  this.getVerify();
                }
              }
            );
          }
        } else {
          this.$message.error("u-key已拔出或驱动程序未打开");
        }
      });
      // 捕捉ukey错误
      setTimeout(() => {
        // 读不到ukey信息时报错
        if (num === 0) {
          this.$message.error("u-key已拔出或驱动程序未打开");
        }
      }, 500);
    },
    // 登陆
    login() {
      let params = {
        data: {
          params: {
            username: this.form.username,
            password: this.form.password,
            captcha: this.form.captcha,
            ticket: this.ticket,
          },
        },
      };
      this.loading = true;
      API.loginIn(params, (callback) => {
        this.loading = false;
        if (callback.status == "S" && callback.data) {
          const userInfo = callback.data;
          if (userInfo.token) {
            localStorage.setItem("token", userInfo.token);
          }
          this.setUserInfo(callback.data.user);
          this.setRole(callback.data.role);
          this.getArea();

          if (Array.isArray(userInfo.menus) && userInfo.menus.length > 0) {
            let menus = [];
            // this.$router.push("/");
            menus = userInfo.menus;
            this.setMenus(menus);
            if (menus[0].children.length == 0) {
              this.$router.push(menus[0].path);
            } else {
              this.$router.push(menus[0].children[0].path);
            }
          }
        } else {
          this.form.captcha = "";
          this.getVerify();
        }
      });
    },
    // 下载uk使用说明
    downloadNote() {
      window.location.href = "/doc/数字证书UKEY使用说明文档.docx";
    },
    // 下载Ukey驱动下载
    downloadDriver() {
      window.location.href = "/doc/证书应用环境安装程序V3.4.exe";
    },
    // 获取全量的行政区划
    getArea() {
      COMMONAPI.getAllAreaInfoTree({}, (callback) => {
        let res = []
        if (callback.status == "S" && callback.data) {
          res = callback.data;
        }
        this.setArea(res);
      });
    },
    ...mapMutations(
      [
        "setUserInfo",
        "setMenus",
        "setAuthTreeData",
        "setAuthButtonList",
        "setUrlCookie",
        "setDefaultRouter",
        "setRole",
        "setArea"
      ]
      // { setTabs: 'tabs/setTabs' }
    ),
  },
};
</script>
